export default "__VITE_ASSET__8dDvlK0F__"